import { BrowserAnimationsModule} from '@angular/platform-browser/animations'
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { InventoryComponent } from './dashboard/inventory/inventory.component';
import { AuthComponent } from './auth/auth.component';
import { ListComponent } from './dashboard/inventory/list/list.component';
import { ProjectComponent } from './project/project.component';
import { SalesComponent } from './dashboard/sales/sales.component';
import { StatusComponent } from './dashboard/sales/status/status.component';
import { CustomersComponent } from './dashboard/sales/customers/customers.component';
import { DetailsComponent } from './dashboard/sales/details/details.component';
import { LeadsComponent } from './dashboard/leads/leads.component';
import { LeadComponent } from './dashboard/leads/lead/lead.component';
import { InvoiceComponent } from './dashboard/invoice/invoice.component';
import { TemplateComponent } from './dashboard/invoice/template/template.component';
import { ManageLeadsComponent } from './dashboard/leads/manage-leads/manage-leads.component';
import { UsersComponent } from './dashboard/users/users.component';
import { PaymentsComponent } from './dashboard/sales/payments/payments.component';

import { FilterPipe } from './pipes/filter.pipe';
import { SortPipe } from './pipes/sort.pipe';

import { AuthService } from './auth/auth.service';
import { AuthInterceptor } from './auth/interceptor';
import { SharedService } from './dashboard/shared.service';
import { AuthGuard } from './auth/auth.guard';
import { SettingsComponent } from './dashboard/inventory/settings/settings.component';
import { ChannelPartnersComponent } from './dashboard/channel-partners/channel-partners.component';
import { DelearsComponent } from './dashboard/channel-partners/delears/delears.component';
import { SubdelearsComponent } from './dashboard/channel-partners/subdelears/subdelears.component';
import { CreateCustomerComponent } from './dashboard/sales/create-customer/create-customer.component';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    DashboardComponent,
    InventoryComponent,
    AuthComponent,
    ListComponent,
    ProjectComponent,
    SalesComponent,
    StatusComponent,
    CustomersComponent,
    DetailsComponent,
    LeadsComponent,
    LeadComponent,
    InvoiceComponent,
    TemplateComponent,
    ManageLeadsComponent,
    FilterPipe,
    SortPipe,
    UsersComponent,
    PaymentsComponent,
    SettingsComponent,
    ChannelPartnersComponent,
    DelearsComponent,
    SubdelearsComponent,
    CreateCustomerComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SweetAlert2Module.forRoot(),
    AngularMyDatePickerModule,
    NgMultiSelectDropDownModule.forRoot()


  ],
  providers: [
    AuthService,
    SharedService,
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
